import { UnderwritingStatus } from 'growth-payments-core/eligibility/types';
import { useEligibilityBinding } from '../eligibility/eligibilityBinding';

/**
 * This hook is used to check if the payments account is approved. It will handle both HSP and BYOS
 * as both processors will have an "APPROVED" UnderwritingStatus.
 * @param eligibility - Optional eligibility object to use.
 * @returns true if the payments account is approved, false otherwise.
 */

export const useIsPaymentsApproved = eligibility => {
  const [eligibilityFromBinding] = useEligibilityBinding();
  const eligibilityToUse = eligibility || eligibilityFromBinding;
  const underwritingStatus = eligibilityToUse === null || eligibilityToUse === void 0 ? void 0 : eligibilityToUse.underwritingStatus;
  return underwritingStatus === UnderwritingStatus.APPROVED;
};